import { z } from "zod";

export const AddVigilsSchema = z.object({
  count: z.coerce.number(),
});

export const defaultAddVigilsValues = {
  count: 0,
};

export type AddVigilsForm = z.infer<typeof AddVigilsSchema>;
